// extracted by mini-css-extract-plugin
export default {"text":"Friend_text__tFnNX","image":"Friend_image__zXDUm"};